'use strict';

angular.module('observatoireApp')
  .controller('BudgetCitoyenController', ['$scope', '$timeout', 'PublicationsService', function($scope, $timeout, PublicationsService) {

    /* ── Données par année ──────────────────────────────────────────────────── */
    var DATA = {
      2025: {
        totalBudget:            2421,
        recettes:               2420.8,
        depenses:               2323.8,
        solde:                  +97,
        besoinFinancement:      388.77,
        recettes2024:           2016.12,
        depensesCourantes:      1346.31,
        fonctionnement:          900.54,
        interetsDette:           148.61,
        transfertsSubventions:   297.16,
        investissements:         977.49,
        investExterieur:         537.46,
        investInterieur:         440.03,
        hypotheses: {
          croissancePib:         4.2,
          inflation:             4.3,
          tauxChange:            600,
          prixPetrole:           75,
          productionPetroliere:  151023
        },
        croissanceSecteurs: {
          primaire:   5.2,
          secondaire: 3.4,
          tertiaire:  3.4
        },
        brochureUrl:   'assets/docs/budget-citoyen-2025.pdf',
        brochureLabel: 'Brochure Budget Citoyen 2025',
        disponible:    false,
        messages: [
          { icon: 'fa-check-circle', couleur: '#16a34a', titre: 'Premier excédent budgétaire', texte: "Le budget 2025 dégage un excédent de +97 milliards FCFA — une première — grâce à la hausse des recettes (+20 % vs 2024) et à la maîtrise des dépenses." },
          { icon: 'fa-graduation-cap', couleur: '#0354c0', titre: 'Priorité aux secteurs sociaux', texte: "543 milliards FCFA (23,37 % du budget) sont consacrés aux secteurs prioritaires : éducation nationale (196 Mds), santé (126 Mds) et eau & énergie (111 Mds)." },
          { icon: 'fa-line-chart',  couleur: '#d97706', titre: 'Diversification & croissance', texte: "Croissance du PIB attendue à 4,2 % en 2025. Les recettes non pétrolières (1 023 Mds) dépassent désormais les recettes pétrolières (994 Mds), signe d'une diversification réussie." }
        ],
        recettesDetails: [
          { label: 'Recettes non pétrolières', montant: 1023, pct: 42, couleur: '#0354c0' },
          { label: 'Recettes pétrolières',     montant:  994, pct: 41, couleur: '#7c3aed' },
          { label: 'Appuis budgétaires (dons)', montant: 251, pct: 10, couleur: '#16a34a' },
          { label: 'Prêts projets',            montant:  153, pct:  7, couleur: '#d97706' }
        ],
        depensesTotalPrioritaires: 543,
        depenses2024Prioritaires: 507.274,
        depensesDetails: [
          { label: 'Éducation nationale & Promotion civique', montant: 196.46, pct:  8.5, couleur: '#0354c0', icon: 'fa-graduation-cap' },
          { label: 'Santé publique & prévention',             montant: 126.04, pct:  5.4, couleur: '#16a34a', icon: 'fa-heartbeat'      },
          { label: 'Eau & Énergie',                           montant: 110.97, pct:  4.8, couleur: '#0891b2', icon: 'fa-bolt'           },
          { label: 'Enseignement sup., Recherche & Formation',montant:  47.60, pct:  2.1, couleur: '#7c3aed', icon: 'fa-book'           },
          { label: 'Production & Industrialisation agricole', montant:  21.55, pct:  0.9, couleur: '#059669', icon: 'fa-leaf'           },
          { label: 'Action sociale & Humanitaire',            montant:  21.26, pct:  0.9, couleur: '#d97706', icon: 'fa-handshake-o'   },
          { label: 'Élevage & Productions animales',          montant:   9.82, pct:  0.4, couleur: '#16a34a', icon: 'fa-paw'           },
          { label: 'Femme & Petite enfance',                  montant:   9.29, pct:  0.4, couleur: '#ec4899', icon: 'fa-child'          }
        ],
        indicateurs: [
          { icon: 'fa-users',          label: 'Population bénéficiaire',        valeur: '18,5 M',   detail: 'habitants' },
          { icon: 'fa-user',           label: 'Budget par habitant',            valeur: '130 900',  detail: 'FCFA / an' },
          { icon: 'fa-graduation-cap', label: 'Taux de scolarisation primaire', valeur: '76 %',     detail: '(cible 80%)' },
          { icon: 'fa-hospital-o',     label: 'Couverture santé',               valeur: '58 %',     detail: 'des zones couvertes' }
        ]
      },
      2024: {
        totalBudget:   1986,
        recettes:      1712,
        depenses:      1986,
        solde:         -274,
        brochureUrl:   'assets/docs/budget-citoyen-2024.pdf',
        brochureLabel: 'Brochure Budget Citoyen 2024',
        disponible:    false,
        messages: [
          { icon: 'fa-balance-scale', couleur: '#0354c0', titre: 'Consolidation budgétaire',    texte: "Le budget 2024 vise une réduction du déficit grâce à une mobilisation accrue des recettes fiscales et un contrôle rigoureux des dépenses." },
          { icon: 'fa-flask',         couleur: '#16a34a', titre: 'Investissement dans la recherche', texte: "Première tranche du programme national de digitalisation des services publics, avec 45 milliards FCFA dédiés à la transformation numérique." },
          { icon: 'fa-child',         couleur: '#d97706', titre: 'Protection sociale renforcée', texte: "Doublement des allocations aux programmes de protection sociale, ciblant en priorité les ménages vulnérables et les zones rurales." }
        ],
        recettesDetails: [
          { label: 'Recettes fiscales',       montant: 592, pct: 35, couleur: '#0354c0' },
          { label: 'Recettes pétrolières',    montant: 795, pct: 46, couleur: '#7c3aed' },
          { label: 'Dons extérieurs',         montant: 205, pct: 12, couleur: '#16a34a' },
          { label: 'Autres recettes',         montant: 120, pct:  7, couleur: '#d97706' }
        ],
        depensesDetails: [
          { label: 'Éducation',              montant: 318, pct: 16.0, couleur: '#0354c0', icon: 'fa-graduation-cap' },
          { label: 'Santé',                  montant: 218, pct: 11.0, couleur: '#16a34a', icon: 'fa-heartbeat'      },
          { label: 'Sécurité & Défense',     montant: 417, pct: 21.0, couleur: '#dc2626', icon: 'fa-shield'        },
          { label: 'Infrastructures',        montant: 357, pct: 18.0, couleur: '#d97706', icon: 'fa-road'          },
          { label: 'Gouvernance & Admin.',   montant: 318, pct: 16.0, couleur: '#7c3aed', icon: 'fa-university'    },
          { label: 'Service de la dette',    montant: 218, pct: 11.0, couleur: '#0891b2', icon: 'fa-credit-card'   },
          { label: 'Agriculture & Élevage',  montant: 140, pct:  7.0, couleur: '#059669', icon: 'fa-leaf'          }
        ],
        indicateurs: [
          { icon: 'fa-users',      label: 'Population bénéficiaire',        valeur: '18,0 M',   detail: 'habitants' },
          { icon: 'fa-user',       label: 'Budget par habitant',            valeur: '110 300',  detail: 'FCFA / an' },
          { icon: 'fa-graduation-cap', label: 'Taux de scolarisation primaire', valeur: '74 %',     detail: '(cible 78%)' },
          { icon: 'fa-hospital-o', label: 'Couverture santé',               valeur: '54 %',     detail: 'des zones couvertes' }
        ]
      },
      2023: {
        totalBudget:            1885,
        recettes:               1884.8,
        depenses:               1549,
        solde:                  +335,
        besoinFinancement:      null,
        depensesCourantes:      951,
        fonctionnement:          613.79,
        interetsDette:            99,
        transfertsSubventions:   238.21,
        investissements:         598.05,
        investExterieur:         414,
        investInterieur:         184.05,
        depensesTotalPrioritaires: 319.7,
        hypotheses: {
          croissancePib:         5.1,
          inflation:             null,
          tauxChange:            669.1,
          prixPetrole:           85.5,
          productionPetroliere:  142520
        },
        brochureUrl:   'assets/docs/budget-citoyen-2023.pdf',
        brochureLabel: 'Brochure Budget Citoyen 2023',
        disponible:    false,
        messages: [
          { icon: 'fa-check-circle', couleur: '#16a34a', titre: 'Excédent budgétaire de +335 Mds', texte: "Le budget 2023 dégage un excédent important de +335 milliards FCFA, grâce à une mobilisation soutenue des recettes (1 885 Mds) supérieure aux dépenses (1 549 Mds)." },
          { icon: 'fa-graduation-cap', couleur: '#0354c0', titre: 'Secteurs sociaux prioritaires', texte: "319,7 milliards FCFA (financement intérieur) dédiés aux secteurs prioritaires : éducation (141 Mds), santé (79,5 Mds), eau & assainissement (17 Mds)." },
          { icon: 'fa-line-chart', couleur: '#d97706', titre: 'Croissance & pétrole', texte: "Croissance du PIB attendue à 5,1 % avec un pétrole à 85,5 $/baril. Les recettes fiscales pétrolières (574 Mds) et hors pétrole (632 Mds) se rééquilibrent." }
        ],
        recettesDetails: [
          { label: 'Recettes fiscales hors pétrole', montant: 631.6, pct: 34, couleur: '#0354c0' },
          { label: 'Recettes fiscales pétrole',      montant: 573.7, pct: 30, couleur: '#7c3aed' },
          { label: 'Recettes non fiscales',          montant: 485.7, pct: 26, couleur: '#d97706' },
          { label: 'Dons extérieurs',                montant: 193.8, pct: 10, couleur: '#16a34a' }
        ],
        depensesDetails: [
          { label: 'Éducation nationale',          montant: 141.2, pct:  9.1, couleur: '#0354c0', icon: 'fa-graduation-cap' },
          { label: 'Santé',                        montant:  79.5, pct:  5.1, couleur: '#16a34a', icon: 'fa-heartbeat'      },
          { label: 'Enseignement supérieur',       montant:  34.1, pct:  2.2, couleur: '#7c3aed', icon: 'fa-book'           },
          { label: 'Eau & Assainissement',         montant:  17.1, pct:  1.1, couleur: '#0891b2', icon: 'fa-tint'           },
          { label: 'Agriculture',                  montant:  17.7, pct:  1.1, couleur: '#059669', icon: 'fa-leaf'           },
          { label: 'Environnement & Pêche',        montant:  10.3, pct:  0.7, couleur: '#16a34a', icon: 'fa-tree'           },
          { label: 'Genre & Solidarité',           montant:  10.5, pct:  0.7, couleur: '#ec4899', icon: 'fa-child'          },
          { label: 'Élevage',                      montant:   6.4, pct:  0.4, couleur: '#d97706', icon: 'fa-paw'            },
          { label: 'Formation pro & Microfinance', montant:   2.9, pct:  0.2, couleur: '#64748b', icon: 'fa-wrench'         }
        ],
        indicateurs: [
          { icon: 'fa-users',          label: 'Population bénéficiaire',        valeur: '17,5 M',  detail: 'habitants' },
          { icon: 'fa-user',           label: 'Budget par habitant',            valeur: '107 700', detail: 'FCFA / an' },
          { icon: 'fa-graduation-cap', label: 'Taux de scolarisation primaire', valeur: '72 %',    detail: '(cible 76%)' },
          { icon: 'fa-hospital-o',     label: 'Couverture santé',               valeur: '51 %',    detail: 'des zones couvertes' }
        ]
      },
      2022: {
        totalBudget:              1359,
        recettes:                 1359,
        depenses:                 1203,
        solde:                    +156,
        soldeHorsDons:            -13.238,
        depensesCourantes:         787.786,
        fonctionnement:            787.786,
        interetsDette:              54.714,
        transfertsSubventions:     213.850,
        investissements:           360.500,
        investExterieur:           219.050,
        investInterieur:           141.450,
        depensesTotalPrioritaires: 400.306,
        brochureUrl:   'assets/docs/budget-citoyen-2022.pdf',
        brochureLabel: 'Brochure Budget Citoyen 2022',
        disponible:    false,
        messages: [
          { icon: 'fa-check-circle', couleur: '#16a34a', titre: 'Excédent de +156 Mds FCFA',      texte: "Le budget 2022 dégage un excédent de +156 milliards FCFA. Les recettes (1 359 Mds) dépassent les dépenses (1 203 Mds), avec toutefois un solde hors dons de -13 Mds." },
          { icon: 'fa-graduation-cap', couleur: '#0354c0', titre: '400 Mds pour les secteurs sociaux', texte: "400 milliards FCFA, soit 1/3 du budget, sont alloués aux secteurs prioritaires : éducation (166 Mds), santé (103 Mds), agriculture (52 Mds)." },
          { icon: 'fa-tint',         couleur: '#0891b2', titre: 'Fiscalité hors pétrole en hausse', texte: "Les recettes fiscales hors pétrole (537 Mds) dépassent pour la première fois les recettes pétrolières (361 Mds), signe de diversification fiscale." }
        ],
        recettesDetails: [
          { label: 'Recettes fiscales hors pétrole', montant: 536.864, pct: 40, couleur: '#0354c0' },
          { label: 'Recettes fiscales pétrole',      montant: 360.688, pct: 27, couleur: '#7c3aed' },
          { label: 'Recettes non fiscales',          montant: 292.209, pct: 21, couleur: '#d97706' },
          { label: 'Dons extérieurs',                montant: 169.238, pct: 12, couleur: '#16a34a' }
        ],
        depensesDetails: [
          { label: 'Éducation',               montant: 166.046, pct: 13.8, couleur: '#0354c0', icon: 'fa-graduation-cap' },
          { label: 'Santé',                   montant: 103.032, pct:  8.6, couleur: '#16a34a', icon: 'fa-heartbeat'      },
          { label: 'Agriculture',             montant:  51.691, pct:  4.3, couleur: '#059669', icon: 'fa-leaf'           },
          { label: 'Environnement & Pêche',   montant:  23.123, pct:  1.9, couleur: '#16a34a', icon: 'fa-tree'           },
          { label: 'Élevage',                 montant:  21.986, pct:  1.8, couleur: '#d97706', icon: 'fa-paw'            },
          { label: 'Hydraulique (eau)',        montant:  19.859, pct:  1.7, couleur: '#0891b2', icon: 'fa-tint'          },
          { label: 'Formation professionnelle',montant:   6.649, pct:  0.6, couleur: '#7c3aed', icon: 'fa-wrench'        },
          { label: 'Femme & Petite enfance',  montant:   7.918, pct:  0.7, couleur: '#ec4899', icon: 'fa-child'          }
        ],
        indicateurs: [
          { icon: 'fa-users',          label: 'Population bénéficiaire',        valeur: '17,0 M',  detail: 'habitants' },
          { icon: 'fa-user',           label: 'Budget par habitant',            valeur: '79 900',  detail: 'FCFA / an' },
          { icon: 'fa-graduation-cap', label: 'Taux de scolarisation primaire', valeur: '70 %',    detail: '(cible 75%)' },
          { icon: 'fa-hospital-o',     label: 'Couverture santé',               valeur: '48 %',    detail: 'des zones couvertes' }
        ]
      },
      2021: {
        totalBudget:   1504,
        recettes:      1270,
        depenses:      1504,
        solde:         -234,
        brochureUrl:   'assets/docs/budget-citoyen-2021.pdf',
        brochureLabel: 'Brochure Budget Citoyen 2021',
        disponible:    false,
        messages: [
          { icon: 'fa-life-ring',  couleur: '#0354c0', titre: 'Budget de crise & résilience', texte: "Face à la double crise sécuritaire et sanitaire, le budget 2021 a priorisé la résilience avec des filets sociaux renforcés." },
          { icon: 'fa-sun-o',      couleur: '#d97706', titre: 'Énergie solaire rurale',        texte: "Lancement d'un programme solaire rural de 20 milliards FCFA pour électrifier 300 villages isolés d'ici 2023." },
          { icon: 'fa-book',       couleur: '#16a34a', titre: 'Éducation en urgence',          texte: "Malgré les contraintes, 15,8 % du budget ont été alloués à l'éducation, maintenant l'accès aux apprentissages." }
        ],
        recettesDetails: [
          { label: 'Recettes fiscales',       montant: 406, pct: 32, couleur: '#0354c0' },
          { label: 'Recettes pétrolières',    montant: 597, pct: 47, couleur: '#7c3aed' },
          { label: 'Dons extérieurs',         montant: 178, pct: 14, couleur: '#16a34a' },
          { label: 'Autres recettes',         montant:  89, pct:  7, couleur: '#d97706' }
        ],
        depensesDetails: [
          { label: 'Éducation',              montant: 237, pct: 15.8, couleur: '#0354c0', icon: 'fa-graduation-cap' },
          { label: 'Santé',                  montant: 180, pct: 12.0, couleur: '#16a34a', icon: 'fa-heartbeat'      },
          { label: 'Sécurité & Défense',     montant: 316, pct: 21.0, couleur: '#dc2626', icon: 'fa-shield'        },
          { label: 'Infrastructures',        montant: 271, pct: 18.0, couleur: '#d97706', icon: 'fa-road'          },
          { label: 'Gouvernance & Admin.',   montant: 240, pct: 16.0, couleur: '#7c3aed', icon: 'fa-university'    },
          { label: 'Service de la dette',    montant: 165, pct: 11.0, couleur: '#0891b2', icon: 'fa-credit-card'   },
          { label: 'Agriculture & Élevage',  montant:  95, pct:  6.2, couleur: '#059669', icon: 'fa-leaf'          }
        ],
        indicateurs: [
          { icon: 'fa-users',      label: 'Population bénéficiaire',        valeur: '16,6 M',  detail: 'habitants' },
          { icon: 'fa-user',       label: 'Budget par habitant',            valeur: '90 600',  detail: 'FCFA / an' },
          { icon: 'fa-graduation-cap', label: 'Taux de scolarisation primaire', valeur: '68 %',    detail: '(cible 72%)' },
          { icon: 'fa-hospital-o', label: 'Couverture santé',               valeur: '45 %',    detail: 'des zones couvertes' }
        ]
      },
      2020: {
        totalBudget:   1317,
        recettes:      1105,
        depenses:      1317,
        solde:         -212,
        brochureUrl:   'assets/docs/budget-citoyen-2020.pdf',
        brochureLabel: 'Brochure Budget Citoyen 2020',
        disponible:    false,
        messages: [
          { icon: 'fa-bar-chart',  couleur: '#0354c0', titre: 'Budget de stabilisation',    texte: "Le budget 2020 s'inscrit dans une trajectoire de stabilisation des finances publiques avec un effort de rationalisation des dépenses courantes." },
          { icon: 'fa-graduation-cap', couleur: '#16a34a', titre: 'Priorité éducation',    texte: "L'éducation reste le premier poste budgétaire avec 15,5 % des dépenses totales, conformément aux objectifs de l'Agenda 2030." },
          { icon: 'fa-money',      couleur: '#7c3aed', titre: 'Réforme fiscale',             texte: "Adoption d'un nouveau code des impôts visant à élargir l'assiette fiscale et améliorer le recouvrement des recettes non pétrolières." }
        ],
        recettesDetails: [
          { label: 'Recettes fiscales',       montant: 354, pct: 32, couleur: '#0354c0' },
          { label: 'Recettes pétrolières',    montant: 520, pct: 47, couleur: '#7c3aed' },
          { label: 'Dons extérieurs',         montant: 154, pct: 14, couleur: '#16a34a' },
          { label: 'Autres recettes',         montant:  77, pct:  7, couleur: '#d97706' }
        ],
        depensesDetails: [
          { label: 'Éducation',              montant: 204, pct: 15.5, couleur: '#0354c0', icon: 'fa-graduation-cap' },
          { label: 'Santé',                  montant: 158, pct: 12.0, couleur: '#16a34a', icon: 'fa-heartbeat'      },
          { label: 'Sécurité & Défense',     montant: 277, pct: 21.0, couleur: '#dc2626', icon: 'fa-shield'        },
          { label: 'Infrastructures',        montant: 237, pct: 18.0, couleur: '#d97706', icon: 'fa-road'          },
          { label: 'Gouvernance & Admin.',   montant: 211, pct: 16.0, couleur: '#7c3aed', icon: 'fa-university'    },
          { label: 'Service de la dette',    montant: 145, pct: 11.0, couleur: '#0891b2', icon: 'fa-credit-card'   },
          { label: 'Agriculture & Élevage',  montant:  85, pct:  6.5, couleur: '#059669', icon: 'fa-leaf'          }
        ],
        indicateurs: [
          { icon: 'fa-users',      label: 'Population bénéficiaire',        valeur: '16,2 M',  detail: 'habitants' },
          { icon: 'fa-user',       label: 'Budget par habitant',            valeur: '81 300',  detail: 'FCFA / an' },
          { icon: 'fa-graduation-cap', label: 'Taux de scolarisation primaire', valeur: '65 %',    detail: '(cible 70%)' },
          { icon: 'fa-hospital-o', label: 'Couverture santé',               valeur: '42 %',    detail: 'des zones couvertes' }
        ]
      }
    };

    /* ── Années disponibles ─────────────────────────────────────────────────── */
    $scope.annees           = [2025, 2024, 2023, 2022, 2021, 2020];
    $scope.anneesDesactivees = [2024, 2021, 2020];
    $scope.anneeSelectionnee = 2025;
    $scope.data      = DATA[2025];
    $scope.loading   = false;

    /* ── Changement d'année ─────────────────────────────────────────────────── */
    $scope.choisirAnnee = function(annee) {
      if ($scope.anneeSelectionnee === annee) return;
      if ($scope.anneesDesactivees.indexOf(annee) !== -1) return;
      $scope.anneeSelectionnee = annee;
      $scope.data = DATA[annee];
    };

    /* ── Association automatique avec les publications ─────────────────────── */
    function chargerBrochuresDepuisPublications() {
      PublicationsService.getAllPublications().then(function(publications) {
        $scope.annees.forEach(function(annee) {
          var match = publications.filter(function(pub) {
            var titre = (pub.title || '').toLowerCase();
            var tags  = (pub.tags || []).join(' ').toLowerCase();
            return (titre.indexOf('budget citoyen') !== -1 || tags.indexOf('budget citoyen') !== -1)
                && (titre.indexOf(String(annee)) !== -1 || tags.indexOf(String(annee)) !== -1);
          }).sort(function(a, b) {
            return (b.downloads || 0) - (a.downloads || 0);
          })[0];

          if (match && match.fileUrl) {
            DATA[annee].brochureUrl   = match.fileUrl;
            DATA[annee].brochureLabel = match.title || DATA[annee].brochureLabel;
            DATA[annee].disponible    = true;
            DATA[annee].publicationId = match.id;
          }
        });

        $scope.data = DATA[$scope.anneeSelectionnee];
      }).catch(angular.noop);
    }

    chargerBrochuresDepuisPublications();

    /* ── Helpers ────────────────────────────────────────────────────────────── */
    $scope.formatMilliards = function(val) {
      if (val == null) return '–';
      return Math.abs(val).toLocaleString('fr-FR') + ' Mds FCFA';
    };

    $scope.soldeLabel = function(val) {
      return val >= 0 ? 'Excédent' : 'Déficit';
    };

    $scope.soldeClass = function(val) {
      return val >= 0 ? 'bc-solde-positif' : 'bc-solde-negatif';
    };
  }]);
